// react libraries
import React, { useContext } from 'react';

// third-party components
import { Form, Row, Col, Button, notification, Input } from 'antd';
import { useMutation } from 'react-query';
import { Link, useHistory } from 'react-router-dom';

// components
import AuthPageWrapper from 'components/AuthPageWrapper';
import { AppStateDispatchContext } from 'AppContext';

// utils
import setAuthToken from 'utils/setAuthToken';

// hooks
import {
  setUserLoggedInUserDataInGlobalStore,
  setUserActiveClinicDataInGlobalStore,
} from 'hooks/useUserAuthData';

// API
import api from 'api';

// styles
import './index.less';

const Signin = () => {
  const { setAppState } = useContext(AppStateDispatchContext);
  const history = useHistory();

  const mutation = useMutation(
    (loginDetails) => api.auth.signin(loginDetails),
    {
      onSuccess: (data) => {
        setAppState({ isAuthenticated: true, ...data.data.data });

        setAuthToken(data.data.data.token);

        localStorage.setItem(
          'whiskerUserDetails',
          JSON.stringify(data.data.data),
        );

        setUserLoggedInUserDataInGlobalStore({
          ...data.data.data,
          isAuthenticated: true,
        });

        setUserActiveClinicDataInGlobalStore(data?.data?.data?.clinics[0]);

        history.push('/d/welcome');
      },
      onError: (error) => {
        notification.error({
          message: 'Signin Error',
          description: `${error.response.data.message}`,
        });
      },
    },
  );

  const handleLogin = (formValues) => {
    mutation.mutate(formValues);
  };

  return (
    <AuthPageWrapper
      formTitle="Sign In"
      subTitle={'Enter your credentials to access your VEA account'}
      maxFormWidth={422}
    >
      <div id="signin">
        <Form layout="vertical" requiredMark={false} onFinish={handleLogin}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, message: 'Please input your email' }]}
              >
                <Input
                  size="large"
                  type="email"
                  placeholder="Enter your email"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: 'Please input your password' },
                ]}
              >
                <Input.Password
                  placeholder="Enter your password"
                  size="large"
                />
              </Form.Item>
            </Col>
            <div className="forgot-password-container">
              <Link to="/forgot-password">
                <Button type="text" style={{ padding: 0 }} size="small">
                  Forgot Password?
                </Button>
              </Link>
            </div>
            <Col span={24}>
              <Button
                type="primary"
                className="custom-button"
                size="large"
                block
                htmlType="submit"
                loading={mutation.isLoading && !mutation.isError}
              >
                {mutation.isLoading && !mutation.isError
                  ? 'Signing in...'
                  : 'Sign In'}
              </Button>
            </Col>
          </Row>

          <p className="signup-link-text">
            {' '}
            Not a member? <Link to="/signup">Sign Up</Link>
          </p>
        </Form>
      </div>
    </AuthPageWrapper>
  );
};

export default Signin;
